import { API_URL } from "../../Env";
import Utils from "../Utils";
import AccountsAPI from "./AccountsAPI";
import axios from 'axios';

const BaseAxios = axios.create({
    baseURL : API_URL
});

const AuthAxios = axios.create({
    baseURL : API_URL
});

let refreshing = false;
let refreshRequest;

AuthAxios.interceptors.request.use(function (config) {
    if(!Utils.CheckUser()){
        window.location.href = "/";
        return Promise.reject(config);
    }
    const { token } = Utils.GetUser();
    config.headers['Authorization'] = "Bearer " + token
    return config;
}, function (error) {
    // Do something with request error
    return Promise.reject(error);
});

AuthAxios.interceptors.response.use((response) => {
    return response;
  }, function (error) {  
    if(error.response && error.response.status == 401){
        return new Promise(async (resolve, reject) => {
            if(!refreshing){
                refreshing = true;
                refreshRequest = AccountsAPI.refreshToken();
                await refreshRequest
                refreshing = false;
            } else {
                await refreshRequest;
            }
            resolve(AuthAxios.request(error.config))
        })
    }
    return Promise.reject(error);
  });

export { AuthAxios, BaseAxios };